import './cspViolationBuffer';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAppInsights } from './initAppInsights';
import NotoEmojiFontDeclaration from './web-stories-wp/story-editor/src/output/utils/NotoEmojiFontDeclaration';

import './index.css';

initAppInsights();

ReactDOM.render(
  <React.StrictMode>
    <NotoEmojiFontDeclaration />
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
